// src/firebase/config.js
import { initializeApp, getApp, getApps } from 'firebase/app';
import { getFirestore, connectFirestoreEmulator } from 'firebase/firestore';
import { getFunctions, connectFunctionsEmulator } from 'firebase/functions';
import { getStorage } from 'firebase/storage';
import { getAuth, setPersistence, browserLocalPersistence }  from 'firebase/auth';
import { getAnalytics, isSupported } from "firebase/analytics";
import { devLog } from '../App';

// CLIENT-SIDE Firebase configuration ONLY
// Never include admin credentials in client-side code!
const firebaseConfig = {
  apiKey: "AIzaSyCNgUqA3-cbpS93T9aD7RXP_ufD5guxt4I",
  authDomain: "aiknowledgebase-7427e.firebaseapp.com",
  projectId: "aiknowledgebase-7427e",
  storageBucket: "aiknowledgebase-7427e.firebasestorage.app",
  messagingSenderId: "569849967691",
  appId: "1:569849967691:web:6c78c6ee2551c420fc89ce",
  measurementId: "G-VTRXQQ7KBQ"
  // NOTE: Removed all admin/service account fields - those belong on the server only!
};

// Initialize Firebase - check if already initialized to prevent errors
let app;
try {
  app = getApps().length === 0 ? initializeApp(firebaseConfig) : getApp();
} catch (error) {
  // If getApp() fails, initialize a new app
  app = initializeApp(firebaseConfig);
}

const db = getFirestore(app);
const storage = getStorage(app);
const auth = getAuth(app);
const functions = getFunctions(app, 'us-central1');

// Optional local emulator support (opt-in via env vars)
// - REACT_APP_USE_FIREBASE_EMULATORS=true → Firestore emulator (127.0.0.1:8080)
// - REACT_APP_CONNECT_FUNCTIONS_EMULATOR=true → Functions emulator (port 5001 by default)
//   Use this without Firestore when only running `firebase emulators:start --only functions`.
const functionsEmuPort = Number(process.env.REACT_APP_FUNCTIONS_EMULATOR_PORT || '5001') || 5001;
if (process.env.REACT_APP_USE_FIREBASE_EMULATORS === 'true') {
  try {
    connectFirestoreEmulator(db, '127.0.0.1', 8080);
    devLog('🧪 Connected Firestore to emulator at 127.0.0.1:8080');
  } catch (e) {
    console.warn('Firestore emulator connection skipped:', e?.message || e);
  }
}
if (
  process.env.REACT_APP_CONNECT_FUNCTIONS_EMULATOR === 'true' ||
  process.env.REACT_APP_USE_FIREBASE_EMULATORS === 'true'
) {
  try {
    connectFunctionsEmulator(functions, '127.0.0.1', functionsEmuPort);
    devLog('🧪 Connected Functions to emulator at 127.0.0.1:' + functionsEmuPort);
  } catch (e) {
    console.warn('Functions emulator connection skipped:', e?.message || e);
  }
}

setPersistence(auth, browserLocalPersistence)
  .then(() => {
    devLog('✅ Auth persistence set to LOCAL - auth will persist across tabs and browser restarts');
  })
  .catch((error) => {
    console.error('❌ Error setting auth persistence:', error);
  });

// Initialize analytics conditionally to prevent errors
let analytics = null;
const initializeAnalytics = async () => {
  try {
    if (await isSupported()) {
      analytics = getAnalytics(app);
      devLog('Firebase Analytics initialized successfully');
    } else {
      console.warn('Firebase Analytics not supported in this environment');
    }
  } catch (error) {
    console.warn('Failed to initialize Firebase Analytics:', error);
  }
};

// Initialize analytics
initializeAnalytics();

// Helper function to get analytics instance
export const getAnalyticsInstance = () => analytics;

// Export the services for use in other files
export { db, app, storage, auth, firebaseConfig, functions };